import React from "react";
import { Button, Modal } from "@mui/material";
import styles from "./EditPromptModal.module.scss";
import { IAIPrompt } from "@/store/models/aiPrompts.models";
import styled from "styled-components";

type Props = {
  openModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  selectedPrompt: IAIPrompt | null;
  setSelectedPrompt: React.Dispatch<React.SetStateAction<IAIPrompt | null>>;
  handleEditPrompt: () => Promise<void>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
  height: 500px;
`;

const StyledTextarea = styled.textarea`
  padding: 10px;
  font-size: 16px;
  border: 1px solid #cfd3d4;
  color: #5e6366;
  border-radius: 8px;
  font-family: "Mont", sans-serif;
  text-align: left;
  resize: none;
  height: 500px;

  &:focus {
    border-color: "#5570f1";
  }
`;

const EditPromptModal = ({
  openModal,
  setOpenModal,
  selectedPrompt,
  setSelectedPrompt,
  handleEditPrompt,
}: Props) => {
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-edit-data"
    >
      <div className={styles.modalContainer}>
        <h3 className={styles.modalTitle}>{selectedPrompt?.title}</h3>
        <div className={styles.modalContent}>
          <label htmlFor="textarea" className={styles.modalLabel}>
            Write a new prompt
          </label>
          <Container>
            <StyledTextarea
              value={selectedPrompt ? selectedPrompt?.prompt : ""}
              onChange={(e) =>
                setSelectedPrompt((prev) => ({
                  ...prev!,
                  prompt: e.target.value,
                }))
              }
            />
          </Container>
        </div>

        <div className={styles.btns}>
          <Button
            sx={{
              textTransform: "capitalize",
              height: "44px",
              width: "174px",
              backgroundColor: "#008000",
              borderRadius: "12px",
              "&:hover": {
                backgroundColor: "#008000",
              },
            }}
            variant="contained"
            onClick={handleEditPrompt}
          >
            Save
          </Button>

          <Button
            variant="outlined"
            sx={{
              textTransform: "capitalize",
              height: "44px",
              width: "174px",
              border: "1px solid #5570F1",
              color: "#5570F1",
              borderRadius: "12px",
            }}
            onClick={() => setOpenModal(false)}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditPromptModal;

